import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=0b0127be&scoped=true&"
import script from "./CModal.vue?vue&type=script&lang=ts&"
export * from "./CModal.vue?vue&type=script&lang=ts&"
import style0 from "./CModal.vue?vue&type=style&index=0&id=0b0127be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0127be",
  null
  
)

export default component.exports